import React from 'react';
import { ChevronDown } from 'lucide-react';

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  options: any[];
  placeholder: string;
}

const Select: React.FC<SelectProps> = ({ options, placeholder, ...props }) => {
  return (
    <div className="relative">
      <select
        {...props}
        className="appearance-none block w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 text-gray-900 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
      >
        <option value="">{placeholder}</option>
        {options.map(option => (
          <option key={option} value={typeof option == 'object' ? option.value : option}>{typeof option == 'object' ? option.label : option}</option>
        ))}
      </select>
      <ChevronDown className="pointer-events-none absolute right-3 top-2.5 h-5 w-5 text-gray-400" />
    </div>
  );
};

export default Select;